.card {
  width: 300px;
  box-sizing: border-box;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.header {
  display: flex;
  align-items: center;
  gap: 14px;
}

.avatar {
  position: relative;
  flex: none;
  display: inline-flex;
}

/* The ring is the card surface, so the dot reads as cut out of the avatar */
.presenceDot {
  position: absolute;
  right: 0;
  bottom: 1px;
  width: 14px;
  height: 14px;
  box-sizing: border-box;
  border-radius: var(--tuna-shape-radius-circle);
  background-color: var(--tuna-palette-success-main);
  border: 3px solid var(--tuna-surface-elevated);
}

.identity {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.nameRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.name {
  font-size: var(--tuna-typography-fontSize-lg);
  font-weight: 600;
  overflow-wrap: anywhere;
}

.secondary {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-content-secondary);
}

.badge {
  font-size: var(--tuna-typography-fontSize-2xs);
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--tuna-content-primary);
  background-color: color-mix(in oklch, var(--tuna-palette-primary-main) 16%, transparent);
  padding: 2px 6px;
  border-radius: var(--tuna-shape-radius-sm);
}

.parts {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.part {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-content-primary);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-pill);
  padding: 2px 8px;
}

.presence {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-secondary);
}

.presenceInline {
  width: 8px;
  height: 8px;
  border-radius: var(--tuna-shape-radius-circle);
  background-color: var(--tuna-palette-success-main);
  flex: none;
}
